import React, { useCallback, useEffect, useState } from "react";
import { connectRozetkaManualPrro, getRozetkaPrro, getRozetkaReceipts, retryRozetkaReceipt } from "../../api/rozetkaApi";

const PAGE_SIZE = 50;
const statusLabels = { pending: "Ожидает отправки", in_progress: "Отправляется", sent: "Отправлен", dead: "Ошибка" };
const formatTime = (value) => value ? new Date(value).toLocaleString("ru-RU", { timeZone: "Europe/Kyiv" }) : "—";

export default function RozetkaReceipts({ account, enabled, onEnabledChange, onSave, saving }) {
    const [rows, setRows] = useState([]);
    const [offset, setOffset] = useState(0);
    const [prro, setPrro] = useState(null);
    const [message, setMessage] = useState("");
    const [busy, setBusy] = useState(false);
    const load = useCallback(async () => {
        const result = await getRozetkaReceipts(account.id, { limit: PAGE_SIZE, offset });
        setRows(result || []);
    }, [account.id, offset]);

    useEffect(() => { setOffset(0); setPrro(null); setMessage(""); setRows([]); }, [account.id]);
    useEffect(() => {
        let active = true;
        getRozetkaReceipts(account.id, { limit: PAGE_SIZE, offset })
            .then((result) => { if (active) setRows(result || []); })
            .catch(() => { if (active) setMessage("Не удалось загрузить отправки чеков."); });
        return () => { active = false; };
    }, [account.id, offset]);

    const run = async (action) => {
        setBusy(true); setMessage("");
        try { await action(); }
        catch (error) { setMessage(error?.response?.data?.detail || "Не удалось выполнить действие."); }
        finally { setBusy(false); }
    };

    return <section className="rzm-card">
        <h3>Чеки Checkbox → Rozetka</h3>
        <p className="rzm-hint">После включения новые чеки автоматически создаются по действующим правилам Checkbox и передаются в Rozetka. Старые чеки не отправляются. Другая ссылка в заказе заменяется нашей.</p>
        <label><input type="checkbox" checked={!!enabled} onChange={(event) => onEnabledChange(event.target.checked)} /> Автоматически отправлять новые чеки</label>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 12 }}>
            <button type="button" className="rzm-btn rzm-btn-primary" disabled={saving || busy} onClick={onSave}>Сохранить настройки</button>
            <button type="button" className="rzm-btn" disabled={busy} onClick={() => run(async () => setPrro(await getRozetkaPrro(account.id)))}>Проверить подключение ПРРО</button>
            <button type="button" className="rzm-btn" disabled={busy} onClick={() => run(async () => {
                setPrro(await connectRozetkaManualPrro(account.id));
                setMessage("Ручной режим подключён. Отправка чеков будет автоматической после включения и сохранения настройки.");
            })}>Подключить ручной режим ПРРО</button>
            <button type="button" className="rzm-btn" disabled={busy} onClick={() => run(load)}>Обновить отправки</button>
        </div>
        <p className="rzm-hint">Сначала подключите ручной режим ПРРО Rozetka с правом prro_access. Он позволяет автоматически передавать готовую ссылку Checkbox. Если подключён другой ПРРО, его нужно отключить в кабинете Rozetka.</p>
        {prro && <p role="status">ПРРО: {prro.manual_mode ? "ручной режим подключён" : prro.connected ? `подключён другой сервис: ${prro.service_name || prro.service}` : "не подключён"}.</p>}
        {account.receipt_link_sync_started_at && <p className="rzm-hint">Чеки учитываются с {formatTime(account.receipt_link_sync_started_at)} (Киев).</p>}
        {(!account.is_active || !account.orders_enabled || !account.order_live_send_enabled) && <p className="rzm-warn">Для отправки должны быть включены аккаунт, polling заказов и Live send.</p>}
        {message && <p role="status">{message}</p>}
        <div style={{ overflowX: "auto" }}><table className="rzm-table">
            <thead><tr><th>Заказ Rozetka</th><th>SalesDrive</th><th>Чек</th><th>Состояние</th><th>Попытки</th><th>Обновлено (Киев)</th><th>Ошибка</th><th /></tr></thead>
            <tbody>{rows.map((row) => <tr key={row.id}>
                <td>{row.external_order_id}</td><td>{row.salesdrive_order_id || "—"}</td>
                <td>{row.receipt_url?.startsWith("https://") ? <a href={row.receipt_url} target="_blank" rel="noreferrer">Открыть чек</a> : "—"}</td>
                <td>{statusLabels[row.status] || row.status}</td><td>{row.attempts}</td><td>{formatTime(row.updated_at)}</td><td>{row.last_error || "—"}</td>
                <td>{row.status === "dead" && <button type="button" className="rzm-btn" disabled={busy || !account.receipt_link_sync_enabled} onClick={() => run(async () => {
                    await retryRozetkaReceipt(account.id, row.id); await load();
                })}>Повторить</button>}</td>
            </tr>)}</tbody>
        </table></div>
        {rows.length === 0 && <p className="rzm-hint">Отправок чеков пока нет.</p>}
        <div style={{ display: "flex", gap: 10 }}>
            <button type="button" className="rzm-btn" disabled={busy || offset === 0} onClick={() => setOffset(Math.max(0, offset - PAGE_SIZE))}>Назад</button>
            <button type="button" className="rzm-btn" disabled={busy || rows.length < PAGE_SIZE} onClick={() => setOffset(offset + PAGE_SIZE)}>Далее</button>
        </div>
    </section>;
}
